import React, { useEffect, useState } from "react";
import { MobileModalBody } from "./MobileModalBody";
import { MobileModalHeader } from "./MobileModalHeader";
import MobileModal from "./MobileModal";
import { useMediaQuery } from "react-responsive";
import BookSlot from "./BookSlot";
import { getStartAndEndTime } from "../../_helper/utils.js/utils";
import { useAtom } from "jotai";
import { useCreateItem } from "../../../_helper/actions/mutation/items";
import moment from "moment";
import { dateAtom } from "../atom/AppointmentAtoms";
import CuModal from "../../../common_component/component/CuModal";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { toast } from "react-toastify";
import { dateConvertToPayloadBookingFormat } from "../../../components/admin/setup/helper/Helper";
import { getParentUser } from "../../../components/admin/setup/helper/Helper";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { useItemsFilter } from "../../../_helper/actions/app/items";

export const BookEvent = ({
  isOpen,
  setIsOpen,
  onclktime,
  events,
  selectedDoctorId,
  clinicOptions,
  selectedClinicOption,
  setSelectedClinicOption,
}) => {
  const [formData, setFormData] = useState({
    user_details: {
      full_name: "",
      phone: "",
      dob: "",
      age: "",
      gender: "",
    },
    start_time: "",
    end_time: "",
    duration: 5,
    is_walk_in: true,
    status: "booked",
    InjuryNumber: "",
    ipdNumber: "",
    opdNumber: "",
  });
  const [existingUserData, setExistingUserData] = useState([]);
  const [date] = useAtom(dateAtom);
  const [clinic] = useAtom(clinicAtom);
  const [institutionCustmer, setInstitutionCustmer] = useState(null);
  const [isNotification, setIsNotification] = useState(false);
  const [patientType, setPatientType] = useState("existing");
  const [isEdit, setIsEdit] = useState(false);

  const resetState = () => {
    setFormData((prev) => ({
      user_details: {
        full_name: "",
        phone: "",
        dob: "",
        age: "",
        gender: "",
      },
      start_time: prev?.start_time,
      end_time: prev?.end_time,
      duration: 5,
      is_walk_in: true,
      status: "booked",
      InjuryNumber: "",
      ipd: "",
      opdNumber: "",
    }));
    setExistingUserData([]);
    setInstitutionCustmer("");
    setIsEdit(false);
  };

  useEffect(() => {
    if (isOpen?.type === "open") {
      setFormData((prev) => ({
        ...prev,
        start_time: isOpen?.startTime,
        end_time: isOpen?.endTime,
      }));
    } else {
      if (onclktime) {
        setFormData((prev) => ({
          ...prev,
          start_time: onclktime?.time,
        }));
      }
    }
  }, [onclktime, isOpen]);

  const createOPDMutation = useCreateItem(ApiEndPoint.QP_CM_CONSULTATION_DATA);

  const { data: existingUser, isLoading: existingUserLoading } = useItemsFilter(
    ApiEndPoint?.USERS,
    `?action=getSearchPatient&clinic_id=${clinic?.id}&backend=True&family_id=${formData?.user_details?.phone}`,
    !institutionCustmer &&
      formData?.user_details?.phone?.length >= 10 &&
      clinic?.id
      ? true
      : false,
    "",
    0
  );

  const { data: patientData } = useItemsFilter(
    ApiEndPoint.USERS,
    `?clinic_id=${clinic?.id}&backend=True&action=getUsers&email=${formData?.user_details?.phone}@institute${institutionCustmer}.com`,
    formData?.user_details?.phone?.length >= 10 &&
      clinic?.id &&
      institutionCustmer
      ? true
      : false,
    "",
    0
  );

  const { data: customFields } = useItemsFilter(
    "clinics/custom_fields_value/",
    `?action=getCustomFields&clinic_id=${clinic?.id}&backend=True&module_name=book_appointment`,
    clinic?.id ? true : false
  );

  useEffect(() => {
    if (patientData?.length > 0 && patientData[0]?.patients?.length > 0) {
      setFormData((prev) => ({
        ...prev,
        user_details: {
          id: patientData[0]?.patients[0]?.id,
          full_name: patientData[0]?.patients[0]?.full_name,
          phone: patientData[0]?.patients[0]?.phone,
          dob: patientData[0]?.patients[0]?.dob,
          age: patientData[0]?.patients[0]?.age,
          gender: patientData[0]?.patients[0]?.gender,
          family_id: patientData[0]?.patients[0]?.family_id,
          is_parent: patientData[0]?.patients[0]?.is_parent,
          user: patientData[0]?.id,
        },
      }));
      const options = patientData[0]?.patients?.map((user) => ({
        key: user?.id,
        value: user?.id,
        text: user?.full_name,
      }));

      setExistingUserData(options || []);
    }
  }, [patientData]);

  useEffect(() => {
    if (existingUser) {
      const options = existingUser?.map((user) => ({
        key: user?.id,
        value: user?.id,
        text: user?.full_name,
      }));
      const parentUserId = existingUser?.find(
        (user) => user?.is_parent === true
      );
      setExistingUserData(options || []);
      setFormData((prev) => ({
        ...prev,
        user_details: {
          ...prev?.user_details,
          user: parentUserId?.user,
        },
      }));
    }
    // if (existingUser && existingUser?.length === 1) {
    //   const options = existingUser?.map((user) => ({
    //     key: user?.id,
    //     value: user?.id,
    //     text: user?.full_name,
    //   }));

    //   setExistingUserData(options || []);
    //   setFormData((prev) => ({
    //     ...prev,
    //     user_details: { ...existingUser[0] },
    //   }));
    // } else if (existingUser) {
    //   const options = existingUser?.map((user) => ({
    //     key: user?.id,
    //     value: user?.id,
    //     text: user?.full_name,
    //   }));
    //   const parentUserId = existingUser?.find(
    //     (user) => user?.is_parent === true
    //   );
    //   setExistingUserData(options || []);
    //   setFormData((prev) => ({
    //     ...prev,
    //     user_details: {
    //       ...prev?.user_details,
    //       user: parentUserId?.user,
    //     },
    //   }));
    // }
  }, [existingUser]);

  const postOpdNumber = (slot_id, userId) => {
    const { start_time } = getStartAndEndTime(
      date,
      formData?.start_time,
      formData?.end_time
    );

    if (formData?.opdNumber?.length > 0) {
      const payload = {
        action: "postConsultationData",
        transaction_type: "OPD",
        frontend: "True",
        // advice_and_direction: "test",
        // test_investigation: "test",
        clinic_id: clinic?.id,
        doctor_user: selectedDoctorId,
        opd_number: formData?.opdNumber,
        personal_details: userId,
        slot_id: slot_id,
        opd_date: dateConvertToPayloadBookingFormat(start_time),
        feature_name: "consultation",
      };

      createOPDMutation.mutate(payload, {
        onSuccess: (data) => {},
        onError: () => {},
      });
    }

    return;
  };

  const validateName = (fname) => {
    const fullName = fname?.split(" ");
    if (fullName?.length > 1) {
      if (fullName[0].length === 0 || fullName[1].length === 0) {
        toast.warning("Please enter last name");
        return false;
      }
    } else {
      toast.warning("Please enter last name");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    const fullName = formData?.user_details?.full_name?.split(" ");
    if (fullName?.length > 1) {
      if (fullName[0].length === 0 || fullName[1].length === 0) {
        toast.error("Please enter last name");
        return false;
      }
    } else {
      toast.error("Please enter last name");
      return false;
    }

    if (formData?.user_details?.full_name.length > 50) {
      toast.error("Name is too long");
      return false;
    }
    if (!formData?.user_details?.age) {
      toast.warning("Age is required");
      return false;
    } else if (
      isNaN(formData?.user_details?.age) ||
      parseFloat(formData?.user_details?.age) <= 0.01
    ) {
      toast.warning("Invalid age");
      return false;
    }

    if (!formData?.user_details?.gender) {
      toast.warning("Gender is required");
      return false;
    }

    return true;
  };

  const getPayloadForNewUser = (form) => {
    const fullName = form?.user_details?.full_name?.trim()?.split(" ");

    const first_name = fullName[0];
    const last_name = fullName[fullName.length - 1];

    const { start_time, end_time } = getStartAndEndTime(
      date,
      form?.start_time,
      form?.end_time
    );

    const startTime = moment(start_time);
    const endTime = moment(end_time);
    const durationInMillis = endTime.diff(startTime);
    const durationInMinutes = moment.duration(durationInMillis).minutes();

    const registerPayload = {
      action: "postSlots",
      duration: durationInMinutes,
      start_time: dateConvertToPayloadBookingFormat(start_time),
      end_time: dateConvertToPayloadBookingFormat(end_time),
      feature_name: "appointment",
      is_online: false,
      is_walk_in: true,
      frontend: "True",
      status: "booked",
      clinic_id: selectedClinicOption,
      doctor_user: selectedDoctorId,
      notification: isNotification,

      user_details: {
        age: form?.user_details?.age,
        dob: form?.user_details?.dob,
        phone: `${form?.user_details?.phone}`,
        full_name: first_name + " " + last_name,
        gender: form?.user_details?.gender,
        is_parent: true,
        family_id: form?.user_details?.phone,
        user: {
          first_name: first_name,
          last_name: last_name,
          email: `${form?.user_details?.phone}@${
            institutionCustmer ? `institute${institutionCustmer}` : "gmail"
          }.com`,
          mobile: `${form?.user_details?.phone}`,
          password1: "abc12345",
          password2: "abc12345",
          is_doctor: false,
          is_patient: true,
        },
      },

      custom_field_1: {
        custom_field: customFields[0]?.id,
        name: customFields[0]?.name,
        display_name: customFields[0]?.display_name,
        value: formData?.InjuryNumber,
      },
      ipd_data: {
        ipd_number: formData?.ipdNumber,
      },
    };

    return registerPayload;
  };

  const closeModal = () => {
    setIsOpen({ flag: false, startTime: "", type: "walkin" });
    setFormData({
      user_details: {
        full_name: "",
        phone: "",
        dob: "",
        age: "",
        gender: "",
      },
      start_time: "",
      end_time: "",
      duration: 5,
      is_walk_in: true,
      status: "booked",
      InjuryNumber: "",
      ipd: "",
      opd: "",
    });
    setExistingUserData([]);
  };

  const handleChange = (value, label) => {
    if (label === "user_details") {
      const key = Object.keys(value)[0];
      if (key === "phone" && value[key]?.length > 10) {
        return;
      }
      if (
        key === "phone" &&
        formData?.user_details?.phone?.length === 10 &&
        value[key]?.length < 10
      ) {
        setFormData((prev) => ({
          ...prev,
          user_details: {
            full_name: "",
            phone: value[key],
            dob: "",
            age: "",
            gender: "",
          },
        }));
        return;
      }
      setFormData((prev) => ({
        ...prev,
        user_details: { ...prev.user_details, ...value },
      }));
      return;
    }
    if (label === "userId" && typeof value === "number") {
      const userList =
        institutionCustmer && patientData?.length > 0
          ? patientData[0]?.patients || []
          : existingUser || [];

      const user_details = userList?.find((user) => user?.id === value);

      setFormData((prev) => ({ ...prev, user_details }));
      setIsEdit(true);
      return;
    }
    setFormData((prev) => ({ ...prev, [label]: value }));
  };

  const slotBookedSuccessful = (response) => {
    closeModal();
    postOpdNumber(response?.data?.id, response?.data?.user_details?.id);
    toast.success("Slot booked successfully");
  };

  const slotBookedUnsuccessful = (err) => {
    toast.error(err?.response?.data?.message);
  };
  const postSlotMutation = useCreateItem(ApiEndPoint?.QM_SC_SLOTS);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValidate = validateForm();
    if (isValidate) {
      const { start_time, end_time } = getStartAndEndTime(
        date,
        formData?.start_time,
        formData?.end_time
      );

      const startTime = moment(start_time);
      const endTime = moment(end_time);
      const durationInMillis = endTime.diff(startTime);
      const durationInMinutes = moment.duration(durationInMillis).minutes();

      let type = "existing";

      if (institutionCustmer && patientData?.length === 0) {
        type = "new";
      }

      if (!institutionCustmer && existingUserData?.length === 0) {
        type = "new";
      }

      const fullName = formData?.user_details?.full_name;

      const { age, dob, phone, full_name, gender, is_parent, id, user } =
        formData?.user_details;

      let slotPayload = {
        doctor_user: selectedDoctorId,
        clinic_id: selectedClinicOption,
        user_details: {
          age,
          dob,
          phone,
          full_name,
          gender,
          is_parent,
          id,
          user,
        },
        start_time: dateConvertToPayloadBookingFormat(start_time),
        end_time: dateConvertToPayloadBookingFormat(end_time),
        duration: durationInMinutes,
        is_walk_in: true,
        is_online: false,
        notification: isNotification,
        status: "booked",
        action: "postSlots",
        frontend: "True",
        custom_field_1: {
          custom_field: customFields[0]?.id,
          name: customFields[0]?.name,
          display_name: customFields[0]?.display_name,
          value: formData?.InjuryNumber,
          offset: "offset",
        },
        ipd_data: {
          ipd_number: formData?.ipdNumber,
        },
      };

      if (patientType === "new") {
        slotPayload = {
          action: "postSlots",
          frontend: "True",
          duration: durationInMinutes,
          start_time: dateConvertToPayloadBookingFormat(start_time),
          end_time: dateConvertToPayloadBookingFormat(end_time),
          is_online: false,
          is_walk_in: true,
          status: "booked",
          clinic_id: clinic?.id,
          doctor_user: selectedDoctorId,
          notification: isNotification,
          feature_name: "appointment",
          user_details: {
            age: formData?.user_details?.age,
            dob: formData?.user_details?.dob,
            full_name: fullName,
            gender: formData?.user_details?.gender,
            is_parent: false,
            phone: formData?.user_details?.phone,
            family_id: formData?.user_details?.phone,
            user: formData?.user_details?.user,
          },
          custom_field_1: {
            custom_field: customFields[0]?.id,
            name: customFields[0]?.name,
            display_name: customFields[0]?.display_name,
            value: formData?.InjuryNumber,
            offset: "offset",
          },
          ipd_data: {
            ipd_number: formData?.ipdNumber,
          },
        };
      }

      if (type === "new") {
        slotPayload = getPayloadForNewUser(formData);
      }

      if (customFields?.length === 0 || !formData?.InjuryNumber) {
        delete slotPayload.custom_field_1;
      }

      if (!formData?.ipdNumber) {
        delete slotPayload.ipd_data;
      }

      postSlotMutation.mutate(slotPayload, {
        onSuccess: (data) => {
          slotBookedSuccessful(data);
        },
        onError: (err) => {
          slotBookedUnsuccessful(err);
        },
      });
    }
  };

  const handleAddNewFamilyMember = (val) => {
    const parent = getParentUser(existingUser);

    if (validateName(val)) {
      setExistingUserData((prev) => [
        ...prev,
        { key: val, value: val, text: val },
      ]);
      setFormData((prev) => ({
        ...prev,
        user_details: {
          ...prev?.user_details,
          full_name: val,
          gender: "",
          is_parent: false,
          user: parent?.user,
        },
      }));
    }
    setPatientType("new");
  };

  const handleSelectInstitution = (val) => {
    setInstitutionCustmer(val);
  };

  const sm = !useMediaQuery({ query: "(min-width:1024px)" });

  return (
    <div>
      {sm ? (
        <MobileModal
          isOpen={isOpen?.flag}
          closeModal={closeModal}
          modalClassName="modal-container-book-appointment"
          event={"hey"}
        >
          <MobileModalHeader>
            <div className="flex justify-between items-center m-auto w-full">
              <h4 style={{ margin: "10px auto 5px" }}>
                Book a Walk - In Appointment{" "}
              </h4>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5 cursor-pointer"
                onClick={closeModal}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </div>
          </MobileModalHeader>
          <MobileModalBody>
            <BookSlot
              value={formData}
              onChange={handleChange}
              onSubmit={handleSubmit}
              existingUserOptions={
                formData?.user_details?.phone?.length === 10
                  ? existingUserData
                  : []
              }
              handleAddNewFamilyMember={handleAddNewFamilyMember}
              isLoading={existingUserLoading}
              handleSelectInstitution={handleSelectInstitution}
              institutionCustmer={institutionCustmer}
              manualTime={isOpen}
              bookbtnLoading={postSlotMutation.isLoading}
              isNotification={isNotification}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              setIsNotification={setIsNotification}
              customFields={customFields}
              resetState={resetState}
              clinicOptions={clinicOptions}
              selectedClinicOption={selectedClinicOption}
              setSelectedClinicOption={setSelectedClinicOption}
            />
          </MobileModalBody>
        </MobileModal>
      ) : isOpen?.flag ? (
        <CuModal width={"200px"} closeModal={closeModal}>
          <BookSlot
            value={formData}
            onChange={handleChange}
            onSubmit={handleSubmit}
            existingUserOptions={
              formData?.user_details?.phone?.length === 10
                ? existingUserData
                : []
            }
            handleAddNewFamilyMember={handleAddNewFamilyMember}
            isLoading={existingUserLoading}
            bookbtnLoading={postSlotMutation.isLoading}
            handleSelectInstitution={handleSelectInstitution}
            institutionCustmer={institutionCustmer}
            manualTime={isOpen}
            closeModal={closeModal}
            isNotification={isNotification}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            setIsNotification={setIsNotification}
            customFields={customFields}
            resetState={resetState}
            clinicOptions={clinicOptions}
            setSelectedClinicOption={setSelectedClinicOption}
            selectedClinicOption={selectedClinicOption}
          />
        </CuModal>
      ) : (
        <></>
      )}
    </div>
  );
};
